export enum BackgroundLayerType {
  LIGHT_MAP = 'LIGHT_MAP',
  DARK_MAP = 'DARK_MAP',
  CITY_MAP = 'CITY_MAP',
  SATELLITE_MAP = 'SATELLITE_MAP',
}
